import type {
    GetSmsDripSequences as GetSmsDripSequencesQuery,
    RestoreSmsCampaign_smsCampaignRestore_campaign as DripSequence,
    GetSmsDripSequencesVariables as GetDripSequencesQueryVariables,
} from 'nutshell-graphql-types';

import {DRIP_RECIPIENT_STATUS_FILTERS} from '../consts';

import GET_SMS_DRIP_SEQUENCES from './graphql/queries/get-sms-drip-sequences.graphql';

// Removes drip specific filters from showing / considered 'selected'
export const dripSequenceFieldFilterFunction = (fieldName: string) =>
    ![
        'sentSmsDripSequences',
        'receivedSmsDripSequences',
        'viewedSmsDripSequences',
        'clickedSmsDripSequences',
        'period',
        ...DRIP_RECIPIENT_STATUS_FILTERS.map((status) => status.id),
    ].includes(fieldName);

export function dripSequenceDeleteRestoreUpdate(
    proxy: any,
    dripSequence: DripSequence,
    isDeleting: boolean,
    listQueryVariables?: GetDripSequencesQueryVariables
) {
    const queryVariables = listQueryVariables || {};

    try {
        // Update our archived cache
        const cacheResultRemoving: GetSmsDripSequencesQuery | null | undefined = proxy.readQuery({
            query: GET_SMS_DRIP_SEQUENCES,
            variables: {...queryVariables, archived: !isDeleting},
        });

        if (cacheResultRemoving && cacheResultRemoving.smsDripSequences) {
            proxy.writeQuery({
                query: GET_SMS_DRIP_SEQUENCES,
                variables: {...queryVariables, archived: !isDeleting},
                data: {
                    smsDripSequences: {
                        ...cacheResultRemoving.smsDripSequences,
                        edges: cacheResultRemoving.smsDripSequences.edges.filter((edge) => {
                            return edge.node.id !== dripSequence.id;
                        }),
                    },
                },
            });
        }
    } catch {
        // If the above query doesn't exist in the cache, Apollo will throw an
        // error. If that happens, we need to silently catch the error. But we don't want to really do anything
        // with it. The just means we haven't performed this query yet.
    }

    // Update our unarchived cache
    try {
        const cacheResultAdding: GetSmsDripSequencesQuery | null | undefined = proxy.readQuery({
            query: GET_SMS_DRIP_SEQUENCES,
            variables: {...queryVariables, archived: isDeleting},
        });

        if (!cacheResultAdding || !cacheResultAdding.smsDripSequences) {
            return;
        }

        proxy.writeQuery({
            query: GET_SMS_DRIP_SEQUENCES,
            variables: {...queryVariables, archived: isDeleting},
            data: {
                smsDripSequences: {
                    ...cacheResultAdding.smsDripSequences,
                    edges: [
                        {
                            cursor: dripSequence.id,
                            node: dripSequence,
                            __typename: 'SmsDripSequencesEdge',
                        },
                        // @ts-expect-error
                    ].concat(cacheResultAdding.smsDripSequences.edges),
                },
            },
        });
    } catch {
        // If the above query doesn't exist in the cache, Apollo will throw an
        // error. If that happens, we need to silently catch the error. But we don't want to really do anything
        // with it. The just means we haven't performed this query yet.
    }
}
